<template>
  <v-dialog
    v-model="$props.show"
    v-bind="modalSettings"
    @click:outside="!$props.persistent ? $props.close() : null"
  >
    <v-card>
      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>
      <v-divider v-if="showDividers" />
      <v-card-text class="card-body">
        <slot name="text"></slot>
      </v-card-text>
      <v-divider v-if="showDividers" />
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    close: Function,
    persistent: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: 'none'
    },
    showDividers: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    modalSettings () {
      return {
        persistent: this.$props.persistent,
        'max-width': this.$props.maxWidth
      };
    }
  }
};
</script>

<style>
.card-body{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

</style>
